import React from 'react';
import { useSelector } from 'react-redux';
import { Route, Switch } from 'react-router-dom';

// Types
import { OrganizationRole } from 'Shared/constants/types';

// Components
import { WpPageLayout, WpPageHeader, WpPageBody, WpPageTitle } from 'Wpds/components/page-layout';
import { WpTabs, WpTab } from 'Wpds/components/tabs';
import ProfilePage from 'Dashboard/components/SettingsPage/ProfilePage/ProfilePage';
import IntegrationsWrapper from 'Dashboard/components/IntegrationsWrapper/IntegrationsWrapper';
import UserNotifications from 'Dashboard/components/SettingsPage/UserNotifications/UserNotifications';

// Constants
import PageUrls from 'Shared/constants/PageUrls.constants';

const SettingsPage = () => {
  const isOrganizationAdmin = useSelector(state => state.user.organizationRole === OrganizationRole.admin);

  return (
    <WpPageLayout width="container" className="SettingsPage">
      <WpPageHeader>
        <WpPageTitle title="Settings" />
        <WpTabs>
          <WpTab to={PageUrls.SETTINGS_PROFILE_PAGE}>Profile</WpTab>
          <WpTab to={PageUrls.SETTINGS_NOTIFICATIONS_PAGE}>Notifications</WpTab>
          <WpTab to={PageUrls.SETTINGS_INTEGRATIONS_PAGE}>Integrations</WpTab>
          {isOrganizationAdmin && <WpTab to={PageUrls.ADMIN}>Admin Console</WpTab>}
        </WpTabs>
      </WpPageHeader>
      <WpPageBody>
        <Switch>
          <Route exact path={PageUrls.SETTINGS_PROFILE_PAGE} component={ProfilePage} />
          <Route exact path={PageUrls.SETTINGS_INTEGRATIONS_PAGE} component={IntegrationsWrapper} />
          <Route exact path={PageUrls.SETTINGS_NOTIFICATIONS_PAGE} component={UserNotifications} />
        </Switch>
      </WpPageBody>
    </WpPageLayout>
  );
};

export default SettingsPage;
